import React from 'react';
import { FaStar, FaHeart, FaHome, FaShoppingCart } from 'react-icons/fa';
import PostCard from '../components/PostCard';
import { Helmet } from "react-helmet";

function Home() {
  const [favorites, setFavorites] = React.useState([]);
  
  const posts = [
    {
      id: 1,
      title: 'Κλασικά Κουρέματα που Δεν Ξεπερνιούνται Ποτέ',
      excerpt: 'Ανακαλύψτε τα διαχρονικά κουρέματα που παραμένουν στη μόδα για δεκαετίες. Από το fade μέχρι το undercut, μάθετε γιατί αυτά τα στυλ είναι αγαπημένα από όλες τις γενιές.',
      image: '/images/1.jpg',
      date: '15 Ιανουαρίου 2025',
      author: 'Δημήτρης Παπαδόπουλος'
    },
    {
      id: 2,
      title: 'Τέχνη της Ξυριστικής με Ξυράφι: Παραδοσιακή Μέθοδος',
      excerpt: 'Εμβαθύνετε στην αρχαία τέχνη του ξυρίσματος με ίσιο ξυράφι. Μάθετε τις τεχνικές που χρησιμοποιούν οι επαγγελματίες για να επιτύχουν το τέλειο, λείο ξύρισμα.',
      image: '/images/2.jpg',
      date: '12 Ιανουαρίου 2025',
      author: 'Νίκος Γεωργίου'
    },
    {
      id: 3,
      title: 'Περιποίηση Γενειάδας: Συμβουλές από Ειδικούς',
      excerpt: 'Κάντε τη γενειάδα σας να ξεχωρίζει με επαγγελματικές συμβουλές περιποίησης. Μάθετε για τα καλύτερα προϊόντα, τεχνικές styling και πώς να διατηρήσετε τη γενειάδα σας υγιή.',
      image: '/images/3.jpg',
      date: '10 Ιανουαρίου 2025',
      author: 'Κώστας Ανδρέου'
    },
    {
      id: 4,
      title: 'Σύγχρονες Τάσεις στο Ανδρικό Hairstyling 2025',
      excerpt: 'Μείνετε ενημερωμένοι με τις πιο hot τάσεις του 2025. Από τα textured crops μέχρι τα longer styles, ανακαλύψτε τι είναι στη μόδα φέτος.',
      image: '/images/4.jpg',
      date: '8 Ιανουαρίου 2025',
      author: 'Γιάννης Μιχαηλίδης'
    },
    {
      id: 5,
      title: 'Προϊόντα Περιποίησης Μαλλιών που Πρέπει να Δοκιμάσετε',
      excerpt: 'Ανακαλύψτε τα απαραίτητα προϊόντα για την καθημερινή περιποίηση των μαλλιών σας. Pomades, waxes, και clays - μάθετε ποιο προϊόν ταιριάζει στο στυλ σας.',
      image: '/images/5.jpg',
      date: '5 Ιανουαρίου 2025',
      author: 'Παναγιώτης Σταύρου'
    }
  ];

  const handleFavorite = (postId) => {
    setFavorites(prev => {
      if (prev.includes(postId)) {
        return prev.filter(id => id !== postId);
      }
      return [...prev, postId];
    });
  };

  return (
    <>
      <Helmet>
        <title>Fapugo Barbershop - Επαγγελματικό Κουρείο και Περιποίηση</title>
        <meta name="description" content="Fapugo Barbershop - Επαγγελματικές υπηρεσίες κουρέματος και περιποίησης. Ανακαλύψτε τις τελευταίες τάσεις στο ανδρικό στυλ και grooming." />
      </Helmet>

      <div>
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Καλώς Ήρθατε στο Fapugo Barbershop Blog</h1>
          <p className="hero-subtitle">
            Ο προορισμός σας για επαγγελματικές συμβουλές περιποίησης, τελευταίες τάσεις στο ανδρικό στυλ 
            και τεχνικές από έμπειρους barbershop ειδικούς
          </p>
          
          <div className="features-grid">
            <div className="feature-card">
              <FaStar className="feature-icon" />
              <h3 className="feature-title">Επαγγελματική Εμπειρία</h3>
              <p className="feature-description">
                Πάνω από 15 χρόνια εμπειρίας στην τέχνη του κουρέματος και της ανδρικής περιποίησης
              </p>
            </div>
            
            <div className="feature-card">
              <FaHeart className="feature-icon" />
              <h3 className="feature-title">Πάθος για Στυλ</h3>
              <p className="feature-description">
                Αγαπάμε αυτό που κάνουμε και αφοσιωνόμαστε κουρείο κοντά μου να σας βοηθήσουμε να βρείτε το τέλειο στυλ
              </p>
            </div>
            
            <div className="feature-card">
              <FaHome className="feature-icon" />
              <h3 className="feature-title">Σύγχρονες Τάσεις</h3>
              <p className="feature-description">
                Παρακολουθούμε τις τελευταίες τάσεις και τεχνικές στον κόσμο του barbering
              </p>
            </div>
            
            <div className="feature-card">
              <FaShoppingCart className="feature-icon" />
              <h3 className="feature-title">Ποιοτικό Περιεχόμενο</h3>
              <p className="feature-description">
                Άρθρα που προσφέρουν πραγματική αξία και κουρεια κοντα μου χρήσιμες συμβουλές για κάθε άνδρα
              </p>
            </div>
          </div>
          
          <div className="stats-section">
            <div className="stat-item">
              <span className="stat-number">5000+</span>
              <span className="stat-label">Ικανοποιημένοι Αναγνώστες</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">15</span>
              <span className="stat-label">Χρόνια Εμπειρίας</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">200+</span>
              <span className="stat-label">Επαγγελματικά Άρθρα</span>
            </div>
          </div>
          
          <a href="#posts" className="cta-button">
            Ανακαλύψτε τα Άρθρα μας
          </a>
        </div>
      </section>

      <section className="about-blog-section">
        <h2 className="about-blog-title">Το Blog του Fapugo Barbershop</h2>
        <div className="about-blog-content">
          <p>
            Το Fapugo Barbershop Blog είναι ο ιδανικός προορισμός για music barber shop κουρείο κάθε άνδρα που θέλει να παραμείνει 
            ενημερωμένος με τις τελευταίες τάσεις στην ανδρική περιποίηση και το στυλ. Με πάνω από δεκαπέντε 
            χρόνια εμπειρίας στο χώρο του barbering, η ομάδα μας αποτελείται από επαγγελματίες που αφοσιώνονται 
            στην τέχνη του κουρέματος και της ανδρικής περιποίησης.
          </p>
          <p>
            Κάθε άρθρο που δημοσιεύουμε είναι προϊόν εκτενούς έρευνας και πρακτικής εμπειρίας. Από κλασικές 
            τεχνικές ξυρίσματος με ξυράφι μέχρι τις πιο σύγχρονες τάσεις στο hairstyling, καλύπτουμε κάθε 
            πτυχή της ανδρικής περιποίησης. <strong>Η ποιότητα του περιεχομένου μας είναι η πρώτη μας προτεραιότητα</strong>, 
            γι αυτό και κάθε συμβουλή που μοιραζόμαστε έχει δοκιμαστεί και εγκριθεί από τους ειδικούς μας.
          </p>
          <p>
            Το blog μας δεν είναι απλώς μια συλλογή άρθρων, αλλά ένας ολοκληρωμένος οδηγός για τον σύγχρονο 
            άνδρα που θέλει να φροντίζει την εμφάνισή του. Παρέχουμε λεπτομερείς οδηγίες, επαγγελματικές 
            συμβουλές και συστάσεις προϊόντων που θα σας βοηθήσουν να επιτύχετε το το κουρειο τησ γειτονιασ look που επιθυμείτε. 
            <strong>Είμαστε περήφανοι για την κοινότητα που έχουμε χτίσει</strong> και συνεχίζουμε να εμπνεόμαστε 
            από την εμπιστοσύνη των αναγνωστών μας περιποίηση μαλλιών.
          </p>
        </div>
      </section>

      <section id="posts" className="posts-container">
        <h2 className="section-title">Τελευταία Άρθρα</h2>
        <div className="posts-grid">
          {posts.map(post => (
            <PostCard 
              key={post.id} 
              post={post} 
              onFavorite={handleFavorite}
              isFavorite={favorites.includes(post.id)}
            />
          ))}
        </div>
      </section>
    </div>
  
    </>);
}

export default Home;